module.exports = __webpack_public_path__ + "img/hard-drive 1.730a5895.svg";